<!-- TODO improve 404 page -->
<template>
  <div class="content">
    <h1>404</h1>
    <p>Woops, the page you where looking for could not be found <router-link to="/">click here</router-link> to go home</p>
  </div>
</template>

<script>
  export default {
    name: 'p404'
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/p404.vue